module.exports = __webpack_public_path__ + "img/bg.babad190.png";